export var customCategory = 'CUSTOM';
export var frequentCategory = 'FREQUENT';
export var customType = 'SITE';
export var searchCategory = 'SEARCH';
export var yourUploadsCategory = 'USER_CUSTOM';
export var customTitle = 'allUploadsCustomCategory';
export var userCustomTitle = 'userUploadsCustomCategory';
export var dataURLPrefix = 'data:';
export var deleteEmojiLabel = 'delete-emoji';

/**
 * A constant used in sorting/ordering to represent a number 'obviously much bigger than any item in the set being handled'.
 * This is used instead of Number.MAX_VALUE since subtraction of MAX_VALUE from itself occassionaly doesn't equal zero exactly :-(
 */
export var MAX_ORDINAL = 100000;
export var scaledEmojiHeightH1 = 28;
export var scaledEmojiHeightH2 = 26;
export var scaledEmojiHeightH3 = 24;
export var scaledEmojiHeightH4 = 22;
export var denseEmojiHeightH1 = 24.25;
export var denseEmojiHeightH2 = 22.25;
export var denseEmojiHeightH3 = 20.25;
export var denseEmojiHeightH4 = 18.25;
export var defaultEmojiHeight = 20;
export var defaultDenseEmojiHeight = 16.25;
export var emojiPickerWidth = 350;
export var sizeGap = 80;
export var defaultEmojiPickerSize = 'medium';
export var emojiPickerMinHeight = 260;
export var emojiPickerHeight = 295;
export var emojiPickerListHeight = emojiPickerHeight - 58; // picker height - actions height

export var emojiPickerPreviewHeight = 54;
export var emojiPickerHeightWithPreview = emojiPickerHeight + emojiPickerPreviewHeight;
export var localStoragePrefix = 'fabric.emoji';
export var selectedToneStorageKey = "".concat(localStoragePrefix, ".selectedTone");
export var defaultCategories = ['PEOPLE', 'NATURE', 'FOODS', 'ACTIVITY', 'PLACES', 'OBJECTS', 'SYMBOLS', 'FLAGS'];
export var KeyboardKeys = /*#__PURE__*/function (KeyboardKeys) {
  KeyboardKeys["ArrowLeft"] = "ArrowLeft";
  KeyboardKeys["ArrowRight"] = "ArrowRight";
  KeyboardKeys["ArrowUp"] = "ArrowUp";
  KeyboardKeys["ArrowDown"] = "ArrowDown";
  KeyboardKeys["PageUp"] = "PageUp";
  KeyboardKeys["PageDown"] = "PageDown";
  KeyboardKeys["Home"] = "Home";
  KeyboardKeys["End"] = "End";
  KeyboardKeys["Enter"] = "Enter";
  KeyboardKeys["Tab"] = "Tab";
  KeyboardKeys["Space"] = " ";
  KeyboardKeys["Backspace"] = "Backspace";
  return KeyboardKeys;
}({});

// Used to search available emoji in the picker list to focus
export var KeyboardNavigationDirection = /*#__PURE__*/function (KeyboardNavigationDirection) {
  KeyboardNavigationDirection["Down"] = "Down";
  KeyboardNavigationDirection["Up"] = "Up";
  KeyboardNavigationDirection["Left"] = "Left";
  KeyboardNavigationDirection["Right"] = "Right";
  return KeyboardNavigationDirection;
}({});
export var CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED = [KeyboardKeys.ArrowRight, KeyboardKeys.ArrowLeft, KeyboardKeys.Home, KeyboardKeys.End];
export var EMOJI_KEYBOARD_KEYS_SUPPORTED = [KeyboardKeys.Enter, KeyboardKeys.Backspace, KeyboardKeys.Space];
export var TONESELECTOR_KEYBOARD_KEYS_SUPPORTED = [KeyboardKeys.Enter, KeyboardKeys.Tab, KeyboardKeys.Space];
export var EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED = [KeyboardKeys.ArrowRight, KeyboardKeys.ArrowLeft, KeyboardKeys.Home, KeyboardKeys.End, KeyboardKeys.ArrowUp, KeyboardKeys.ArrowDown, KeyboardKeys.PageUp, KeyboardKeys.PageDown];
export var DEFAULT_TONE = 0;
export var defaultListLimit = 50;
export var migrationUserId = 'hipchat_migration_emoticons';
export var analyticsEmojiPrefix = 'atlassian.fabric.emoji.picker';
export var EMOJI_LIST_COLUMNS = 8;
export var EMOJI_LIST_PAGE_COUNT = 5;
export var EMOJI_SEARCH_DEBOUNCE = 150;

// This is the base sampling rate in Emoji
export var SAMPLING_RATE_EMOJI_RENDERED_EXP = 20;
// This rate is used in fetching emoji resource
export var SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP = 100;